import '@fontsource-variable/inter-tight';

import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/600.css';
import './global.css';

import { Button, createTheme, Menu, NavLink, rem, Title } from '@mantine/core';

import ButtonStyles from './Button.module.css';
import MenuStyles from './Menu.module.css';
import NavLinkStyles from './NavLink.module.css';
import TitleStyles from './Title.module.css';

export const THEME = createTheme({
  colors: {
    cmmndr: [
      '#ecedff',
      '#d4d6fa',
      '#a7a8f3',
      '#7678ec',
      '#4d50e7',
      '#3436e4',
      '#2729e3',
      '#1b1eca',
      '#1318aa',
      '#0714a0',
    ],
  },
  primaryColor: 'cmmndr',
  fontFamily: 'Inter Tight Variable, sans-serif',
  fontFamilyMonospace: 'IBM Plex Mono, monospace',
  primaryShade: 8,
  lineHeights: {
    xs: rem(14),
    sm: rem(16),
    md: rem(18),
    lg: rem(20),
    xl: rem(22),
  },
  components: {
    Title: Title.extend({
      classNames: TitleStyles,
    }),
    NavLink: NavLink.extend({
      classNames: NavLinkStyles,
    }),
    Button: Button.extend({
      classNames: ButtonStyles,
      vars(theme, props) {
        if (!props.size || props.size === 'sm' || props.size === 'md') {
          return {
            root: {
              '--button-fz': theme.fontSizes.xs,
            },
          };
        }

        return { root: {} };
      },
    }),
    Menu: Menu.extend({
      classNames: MenuStyles,
    }),
  },
});
